import { DataUtils } from './DataUtils';
import { IdUtils } from './IdUtils';

export type { DraggableIssueData, DroppableFolderData } from './DataUtils';

export const TestCaseRepositoryDndUtils = {
  ...DataUtils,
  ...IdUtils,
};
